import { createTripletGlyphIcon } from '../../../utils/createTripletGlyphIcon';

/** Source: `svg-to-react-generator/source-svgs/outline/{S,M,L}/content copy.svg` */
export const ContentCopyIcon = createTripletGlyphIcon('ContentCopyIcon', {
  s: () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.167 3.95056C13.4706 3.95074 13.7168 4.19672 13.7168 4.50037V13.8334C13.7167 13.9791 13.6587 14.12 13.5557 14.223C13.4526 14.3259 13.3126 14.3841 13.167 14.3842H5.16992C4.86635 14.3842 4.61942 14.1369 4.61914 13.8334L4.61719 4.50037C4.61719 4.35454 4.67522 4.21483 4.77832 4.11169C4.88146 4.00855 5.02112 3.95056 5.16699 3.95056H13.167ZM5.71973 13.2836H12.6172V5.05017H5.7168L5.71973 13.2836Z"
        fill="currentColor"
      />
      <path
        d="M10.5 1.28357C10.8038 1.28357 11.0498 1.52962 11.0498 1.83337C11.0498 2.13711 10.8037 2.38318 10.5 2.38318H3.0498V10.5004C3.04961 10.804 2.80363 11.0502 2.5 11.0502C2.19637 11.0502 1.95039 10.804 1.9502 10.5004V1.83337C1.9502 1.52962 2.19624 1.28357 2.5 1.28357H10.5Z"
        fill="currentColor"
      />
    </svg>
  ),
  m: () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.8125 4.5127C15.1163 4.5127 15.3623 4.75874 15.3623 5.0625V15.5625C15.3623 15.7084 15.3043 15.848 15.2012 15.9512C15.098 16.0543 14.9584 16.1123 14.8125 16.1123H5.81543C5.51173 16.1123 5.26571 15.8662 5.26562 15.5625L5.2627 5.0625C5.2627 4.91666 5.32071 4.77697 5.42383 4.67383C5.52697 4.57068 5.66663 4.5127 5.8125 4.5127H14.8125ZM6.36523 15.0127H14.2627V5.6123H6.3623L6.36523 15.0127Z"
        fill="currentColor"
      />
      <path
        d="M11.8125 1.5127C12.1163 1.5127 12.3623 1.75874 12.3623 2.0625C12.3623 2.36626 12.1163 2.6123 11.8125 2.6123H3.3623V11.8125C3.3623 12.1163 3.11626 12.3623 2.8125 12.3623C2.50874 12.3623 2.2627 12.1163 2.2627 11.8125V2.0625C2.2627 1.75874 2.50874 1.5127 2.8125 1.5127H11.8125Z"
        fill="currentColor"
      />
    </svg>
  ),
  l: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.75 6C19.2688 6 20.5 7.23122 20.5 8.75V18.75C20.5 20.2688 19.2688 21.5 17.75 21.5H9.75293C8.23471 21.4998 7.00347 20.2692 7.00293 18.751L7.00098 8.75098C7.00055 7.23189 8.23189 6 9.75098 6H17.75ZM9.75098 7.5C9.0606 7.5 8.50097 8.05967 8.50098 8.75L8.50293 18.75C8.50312 19.4401 9.0629 19.9998 9.75293 20H17.75C18.4404 20 19 19.4404 19 18.75V8.75C19 8.05964 18.4404 7.5 17.75 7.5H9.75098Z"
        fill="currentColor"
      />
      <path
        d="M15.75 2C16.1642 2 16.5 2.33579 16.5 2.75C16.5 3.16421 16.1642 3.5 15.75 3.5H5.75C5.05964 3.5 4.5 4.05964 4.5 4.75V15.75C4.5 16.1642 4.16421 16.5 3.75 16.5C3.33579 16.5 3 16.1642 3 15.75V4.75C3 3.23122 4.23122 2 5.75 2H15.75Z"
        fill="currentColor"
      />
    </svg>
  ),
});
